<form [formGroup]="formGroup" (ngSubmit)="save()" class="form-content astral-sidebar-shell">
  <div class="form-body astral-sidebar-content astral-stack-l">
    <header>
      <h2 class="astral-sidebar-heading">{{ (isNew ? 'COMPANY.BANK_ACCOUNT.ADD_ACCOUNT' : 'COMPANY.BANK_ACCOUNT.EDIT_ACCOUNT') | translate }}</h2>
    </header>

    @if (companyBankAccount.defaultInvoiceAccount) {
      <app-information-block [text]="'COMPANY.BANK_ACCOUNT.INVOICING_ACCOUNT_INFO' | translate"></app-information-block>
    }

    <section class="astral-section-surface astral-stack-m">
      <h3 class="astral-section-heading">{{ 'COMPANY.BANK_ACCOUNT.SECTION.ACCOUNT' | translate }}</h3>
      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
        <astral-input [control]="formGroup.controls['name']"></astral-input>
        <app-autocomplete-remote-paged
          [control]="formGroup.controls['accountId']"
          [service]="accountFilterService"
          [defaultSearch]="'*'"
          [serviceOptions]="accountPlanId"
          (itemSelected)="onAccountSelected($event)"
        ></app-autocomplete-remote-paged>
        <astral-masked-input inputMode="numeric" [control]="formGroup.controls['clearingNumber']" [mask]="clearingMask"></astral-masked-input>
        <astral-masked-input inputMode="numeric" [control]="formGroup.controls['accountNumber']" [mask]="bankAccountMask"></astral-masked-input>
      </astral-layout-group>
      @if (bankName) {
        <app-information-block [text]="('COMPANY.BANK_ACCOUNT.BANK' | translate) + ': ' + bankName"></app-information-block>
      }
    </section>

    <section class="astral-section-surface astral-stack-m">
      <h3 class="astral-section-heading">{{ 'COMPANY.BANK_ACCOUNT.SECTION.PAYMENT_DETAILS' | translate }}</h3>
      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
        <astral-masked-input inputMode="numeric" [control]="formGroup.controls['bankGiroNumber']" [mask]="bankGiroMask"></astral-masked-input>
        <astral-input [control]="formGroup.controls['customerNumber']"></astral-input>
        <astral-input [control]="formGroup.controls['iban']" (focusout)="formatInternationalFields()"></astral-input>
        <astral-input [control]="formGroup.controls['bic']" (focusout)="formatInternationalFields()"></astral-input>
      </astral-layout-group>
    </section>

    @if (company.useCostPlace || company.useProject || company.useCostBearer || company.useCounterpart) {
      <section class="astral-section-surface astral-stack-m">
        <h3 class="astral-section-heading">{{ 'COMPANY.BANK_ACCOUNT.SECTION.ACCOUNTING' | translate }}</h3>
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          @if (company.useCostPlace) {
            <astral-masked-input [control]="formGroup.controls['costPlace']" [mask]="dimensionMask"></astral-masked-input>
          }
          @if (company.useProject) {
            <astral-masked-input [control]="formGroup.controls['project']" [mask]="dimensionMask"></astral-masked-input>
          }
          @if (company.useCostBearer) {
            <astral-masked-input [control]="formGroup.controls['costBearer']" [mask]="dimensionMask"></astral-masked-input>
          }
          @if (company.useCounterpart) {
            <astral-masked-input [control]="formGroup.controls['counterpart']" [mask]="dimensionMask"></astral-masked-input>
          }
        </astral-layout-group>
      </section>
    }

    <section class="astral-section-surface astral-stack-m">
      <h3 class="astral-section-heading">{{ 'COMPANY.BANK_ACCOUNT.SECTION.IMPORT' | translate }}</h3>
      <astral-date-picker
        [control]="formGroup.controls['bankTransactionsImportStartDate']"
        [model]="companyBankAccount.bankTransactionsImportStartDate"
        [label]="'BANK_IMPORT_TRANSACTIONS.IMPORT_FROM_DATE'"
      ></astral-date-picker>
    </section>
  </div>

  <footer class="form-footer astral-sidebar-footer">
    <astral-button variant="primary" type="submit" labelKey="SAVE_BTN" [disabled]="saving"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" [disabled]="saving" (click)="cancel()"></astral-button>
    @if (canDelete) {
      <astral-button variant="secondary" type="button" icon="trash" labelKey="DELETE_BTN" [disabled]="saving" (click)="deleteAccount()"></astral-button>
    }
  </footer>
</form>
